module.exports = __webpack_public_path__ + "img/1566786218.4158b9c7.jpg";